import locale9ec66352 from '../../locales/en.json'
import locale46d057d5 from '../../locales/cn.json'
import locale275327d8 from '../../locales/fr.json'
import locale8db5ed1c from '../../locales/es.json'
import locale11ea1c94 from '../../locales/bn.json'
import locale5b4a7f49 from '../../locales/cz.json'
import locale6c5af57f from '../../locales/de.json'
import locale46c744ff from '../../locales/hi.json'
import localee31a61d6 from '../../locales/it.json'
import locale86f4b04c from '../../locales/jp.json'
import locale2091eb08 from '../../locales/ko.json'
import localeed699b3c from '../../locales/nl.json'
import locale19d0ae38 from '../../locales/pl.json'
import locale00be6ddc from '../../locales/pt.json'
import locale6c3fbcfd from '../../locales/ru.json'
import localedfd4fbf0 from '../../locales/sk.json'
import locale53e79902 from '../../locales/tu.json'
import locale2e5cfb58 from '../../locales/ua.json'
import locale05d3e4e3 from '../../locales/ur.json'
import locale3e23d162 from '../../locales/vt.json'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: false,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: (context) => import('~/utils/config/i18n').then(m => m.default(context)),
  vueI18nLoader: true,
  locales: [{"code":"en","iso":"en-US","file":"en.json"},{"code":"cn","iso":"cn","file":"cn.json"},{"code":"fr","iso":"fr","file":"fr.json"},{"code":"es","iso":"es","file":"es.json"},{"code":"bn","iso":"bn","file":"bn.json"},{"code":"cz","iso":"cz","file":"cz.json"},{"code":"de","iso":"de","file":"de.json"},{"code":"hi","iso":"hi","file":"hi.json"},{"code":"it","iso":"it","file":"it.json"},{"code":"jp","iso":"jp","file":"jp.json"},{"code":"ko","iso":"ko","file":"ko.json"},{"code":"nl","iso":"nl","file":"nl.json"},{"code":"pl","iso":"pl","file":"pl.json"},{"code":"pt","iso":"pt","file":"pt.json"},{"code":"ru","iso":"ru","file":"ru.json"},{"code":"sk","iso":"sk","file":"sk.json"},{"code":"tu","iso":"tu","file":"tu.json"},{"code":"ua","iso":"ua","file":"ua.json"},{"code":"ur","iso":"ur","file":"ur.json"},{"code":"vt","iso":"vt","file":"vt.json"}],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "no_prefix",
  lazy: false,
  langDir: "locales",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":true,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"lang","cookieSecure":false,"fallbackLocale":"en","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: true,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  loadLanguagesAsync: true,
  normalizedLocales: [{"code":"en","iso":"en-US","file":"en.json"},{"code":"cn","iso":"cn","file":"cn.json"},{"code":"fr","iso":"fr","file":"fr.json"},{"code":"es","iso":"es","file":"es.json"},{"code":"bn","iso":"bn","file":"bn.json"},{"code":"cz","iso":"cz","file":"cz.json"},{"code":"de","iso":"de","file":"de.json"},{"code":"hi","iso":"hi","file":"hi.json"},{"code":"it","iso":"it","file":"it.json"},{"code":"jp","iso":"jp","file":"jp.json"},{"code":"ko","iso":"ko","file":"ko.json"},{"code":"nl","iso":"nl","file":"nl.json"},{"code":"pl","iso":"pl","file":"pl.json"},{"code":"pt","iso":"pt","file":"pt.json"},{"code":"ru","iso":"ru","file":"ru.json"},{"code":"sk","iso":"sk","file":"sk.json"},{"code":"tu","iso":"tu","file":"tu.json"},{"code":"ua","iso":"ua","file":"ua.json"},{"code":"ur","iso":"ur","file":"ur.json"},{"code":"vt","iso":"vt","file":"vt.json"}],
  localeCodes: ["en","cn","fr","es","bn","cz","de","hi","it","jp","ko","nl","pl","pt","ru","sk","tu","ua","ur","vt"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "e",
  3: "n",
  4: ".",
  5: "j",
  6: "s",
  7: "o",
  8: "n",
  9: "\"",
  10: ":",
  11: "\"",
  12: ".",
  13: ".",
  14: "/",
  15: "l",
  16: "o",
  17: "c",
  18: "a",
  19: "l",
  20: "e",
  21: "s",
  22: "/",
  23: "e",
  24: "n",
  25: ".",
  26: "j",
  27: "s",
  28: "o",
  29: "n",
  30: "\"",
  31: ",",
  32: "\"",
  33: "c",
  34: "n",
  35: ".",
  36: "j",
  37: "s",
  38: "o",
  39: "n",
  40: "\"",
  41: ":",
  42: "\"",
  43: ".",
  44: ".",
  45: "/",
  46: "l",
  47: "o",
  48: "c",
  49: "a",
  50: "l",
  51: "e",
  52: "s",
  53: "/",
  54: "c",
  55: "n",
  56: ".",
  57: "j",
  58: "s",
  59: "o",
  60: "n",
  61: "\"",
  62: ",",
  63: "\"",
  64: "f",
  65: "r",
  66: ".",
  67: "j",
  68: "s",
  69: "o",
  70: "n",
  71: "\"",
  72: ":",
  73: "\"",
  74: ".",
  75: ".",
  76: "/",
  77: "l",
  78: "o",
  79: "c",
  80: "a",
  81: "l",
  82: "e",
  83: "s",
  84: "/",
  85: "f",
  86: "r",
  87: ".",
  88: "j",
  89: "s",
  90: "o",
  91: "n",
  92: "\"",
  93: ",",
  94: "\"",
  95: "e",
  96: "s",
  97: ".",
  98: "j",
  99: "s",
  100: "o",
  101: "n",
  102: "\"",
  103: ":",
  104: "\"",
  105: ".",
  106: ".",
  107: "/",
  108: "l",
  109: "o",
  110: "c",
  111: "a",
  112: "l",
  113: "e",
  114: "s",
  115: "/",
  116: "e",
  117: "s",
  118: ".",
  119: "j",
  120: "s",
  121: "o",
  122: "n",
  123: "\"",
  124: ",",
  125: "\"",
  126: "b",
  127: "n",
  128: ".",
  129: "j",
  130: "s",
  131: "o",
  132: "n",
  133: "\"",
  134: ":",
  135: "\"",
  136: ".",
  137: ".",
  138: "/",
  139: "l",
  140: "o",
  141: "c",
  142: "a",
  143: "l",
  144: "e",
  145: "s",
  146: "/",
  147: "b",
  148: "n",
  149: ".",
  150: "j",
  151: "s",
  152: "o",
  153: "n",
  154: "\"",
  155: ",",
  156: "\"",
  157: "c",
  158: "z",
  159: ".",
  160: "j",
  161: "s",
  162: "o",
  163: "n",
  164: "\"",
  165: ":",
  166: "\"",
  167: ".",
  168: ".",
  169: "/",
  170: "l",
  171: "o",
  172: "c",
  173: "a",
  174: "l",
  175: "e",
  176: "s",
  177: "/",
  178: "c",
  179: "z",
  180: ".",
  181: "j",
  182: "s",
  183: "o",
  184: "n",
  185: "\"",
  186: ",",
  187: "\"",
  188: "d",
  189: "e",
  190: ".",
  191: "j",
  192: "s",
  193: "o",
  194: "n",
  195: "\"",
  196: ":",
  197: "\"",
  198: ".",
  199: ".",
  200: "/",
  201: "l",
  202: "o",
  203: "c",
  204: "a",
  205: "l",
  206: "e",
  207: "s",
  208: "/",
  209: "d",
  210: "e",
  211: ".",
  212: "j",
  213: "s",
  214: "o",
  215: "n",
  216: "\"",
  217: ",",
  218: "\"",
  219: "h",
  220: "i",
  221: ".",
  222: "j",
  223: "s",
  224: "o",
  225: "n",
  226: "\"",
  227: ":",
  228: "\"",
  229: ".",
  230: ".",
  231: "/",
  232: "l",
  233: "o",
  234: "c",
  235: "a",
  236: "l",
  237: "e",
  238: "s",
  239: "/",
  240: "h",
  241: "i",
  242: ".",
  243: "j",
  244: "s",
  245: "o",
  246: "n",
  247: "\"",
  248: ",",
  249: "\"",
  250: "i",
  251: "t",
  252: ".",
  253: "j",
  254: "s",
  255: "o",
  256: "n",
  257: "\"",
  258: ":",
  259: "\"",
  260: ".",
  261: ".",
  262: "/",
  263: "l",
  264: "o",
  265: "c",
  266: "a",
  267: "l",
  268: "e",
  269: "s",
  270: "/",
  271: "i",
  272: "t",
  273: ".",
  274: "j",
  275: "s",
  276: "o",
  277: "n",
  278: "\"",
  279: ",",
  280: "\"",
  281: "j",
  282: "p",
  283: ".",
  284: "j",
  285: "s",
  286: "o",
  287: "n",
  288: "\"",
  289: ":",
  290: "\"",
  291: ".",
  292: ".",
  293: "/",
  294: "l",
  295: "o",
  296: "c",
  297: "a",
  298: "l",
  299: "e",
  300: "s",
  301: "/",
  302: "j",
  303: "p",
  304: ".",
  305: "j",
  306: "s",
  307: "o",
  308: "n",
  309: "\"",
  310: ",",
  311: "\"",
  312: "k",
  313: "o",
  314: ".",
  315: "j",
  316: "s",
  317: "o",
  318: "n",
  319: "\"",
  320: ":",
  321: "\"",
  322: ".",
  323: ".",
  324: "/",
  325: "l",
  326: "o",
  327: "c",
  328: "a",
  329: "l",
  330: "e",
  331: "s",
  332: "/",
  333: "k",
  334: "o",
  335: ".",
  336: "j",
  337: "s",
  338: "o",
  339: "n",
  340: "\"",
  341: ",",
  342: "\"",
  343: "n",
  344: "l",
  345: ".",
  346: "j",
  347: "s",
  348: "o",
  349: "n",
  350: "\"",
  351: ":",
  352: "\"",
  353: ".",
  354: ".",
  355: "/",
  356: "l",
  357: "o",
  358: "c",
  359: "a",
  360: "l",
  361: "e",
  362: "s",
  363: "/",
  364: "n",
  365: "l",
  366: ".",
  367: "j",
  368: "s",
  369: "o",
  370: "n",
  371: "\"",
  372: ",",
  373: "\"",
  374: "p",
  375: "l",
  376: ".",
  377: "j",
  378: "s",
  379: "o",
  380: "n",
  381: "\"",
  382: ":",
  383: "\"",
  384: ".",
  385: ".",
  386: "/",
  387: "l",
  388: "o",
  389: "c",
  390: "a",
  391: "l",
  392: "e",
  393: "s",
  394: "/",
  395: "p",
  396: "l",
  397: ".",
  398: "j",
  399: "s",
  400: "o",
  401: "n",
  402: "\"",
  403: ",",
  404: "\"",
  405: "p",
  406: "t",
  407: ".",
  408: "j",
  409: "s",
  410: "o",
  411: "n",
  412: "\"",
  413: ":",
  414: "\"",
  415: ".",
  416: ".",
  417: "/",
  418: "l",
  419: "o",
  420: "c",
  421: "a",
  422: "l",
  423: "e",
  424: "s",
  425: "/",
  426: "p",
  427: "t",
  428: ".",
  429: "j",
  430: "s",
  431: "o",
  432: "n",
  433: "\"",
  434: ",",
  435: "\"",
  436: "r",
  437: "u",
  438: ".",
  439: "j",
  440: "s",
  441: "o",
  442: "n",
  443: "\"",
  444: ":",
  445: "\"",
  446: ".",
  447: ".",
  448: "/",
  449: "l",
  450: "o",
  451: "c",
  452: "a",
  453: "l",
  454: "e",
  455: "s",
  456: "/",
  457: "r",
  458: "u",
  459: ".",
  460: "j",
  461: "s",
  462: "o",
  463: "n",
  464: "\"",
  465: ",",
  466: "\"",
  467: "s",
  468: "k",
  469: ".",
  470: "j",
  471: "s",
  472: "o",
  473: "n",
  474: "\"",
  475: ":",
  476: "\"",
  477: ".",
  478: ".",
  479: "/",
  480: "l",
  481: "o",
  482: "c",
  483: "a",
  484: "l",
  485: "e",
  486: "s",
  487: "/",
  488: "s",
  489: "k",
  490: ".",
  491: "j",
  492: "s",
  493: "o",
  494: "n",
  495: "\"",
  496: ",",
  497: "\"",
  498: "t",
  499: "u",
  500: ".",
  501: "j",
  502: "s",
  503: "o",
  504: "n",
  505: "\"",
  506: ":",
  507: "\"",
  508: ".",
  509: ".",
  510: "/",
  511: "l",
  512: "o",
  513: "c",
  514: "a",
  515: "l",
  516: "e",
  517: "s",
  518: "/",
  519: "t",
  520: "u",
  521: ".",
  522: "j",
  523: "s",
  524: "o",
  525: "n",
  526: "\"",
  527: ",",
  528: "\"",
  529: "u",
  530: "a",
  531: ".",
  532: "j",
  533: "s",
  534: "o",
  535: "n",
  536: "\"",
  537: ":",
  538: "\"",
  539: ".",
  540: ".",
  541: "/",
  542: "l",
  543: "o",
  544: "c",
  545: "a",
  546: "l",
  547: "e",
  548: "s",
  549: "/",
  550: "u",
  551: "a",
  552: ".",
  553: "j",
  554: "s",
  555: "o",
  556: "n",
  557: "\"",
  558: ",",
  559: "\"",
  560: "u",
  561: "r",
  562: ".",
  563: "j",
  564: "s",
  565: "o",
  566: "n",
  567: "\"",
  568: ":",
  569: "\"",
  570: ".",
  571: ".",
  572: "/",
  573: "l",
  574: "o",
  575: "c",
  576: "a",
  577: "l",
  578: "e",
  579: "s",
  580: "/",
  581: "u",
  582: "r",
  583: ".",
  584: "j",
  585: "s",
  586: "o",
  587: "n",
  588: "\"",
  589: ",",
  590: "\"",
  591: "v",
  592: "t",
  593: ".",
  594: "j",
  595: "s",
  596: "o",
  597: "n",
  598: "\"",
  599: ":",
  600: "\"",
  601: ".",
  602: ".",
  603: "/",
  604: "l",
  605: "o",
  606: "c",
  607: "a",
  608: "l",
  609: "e",
  610: "s",
  611: "/",
  612: "v",
  613: "t",
  614: ".",
  615: "j",
  616: "s",
  617: "o",
  618: "n",
  619: "\"",
  620: "}",
}

export const localeMessages = {
  'en.json': () => Promise.resolve(locale9ec66352),
  'cn.json': () => Promise.resolve(locale46d057d5),
  'fr.json': () => Promise.resolve(locale275327d8),
  'es.json': () => Promise.resolve(locale8db5ed1c),
  'bn.json': () => Promise.resolve(locale11ea1c94),
  'cz.json': () => Promise.resolve(locale5b4a7f49),
  'de.json': () => Promise.resolve(locale6c5af57f),
  'hi.json': () => Promise.resolve(locale46c744ff),
  'it.json': () => Promise.resolve(localee31a61d6),
  'jp.json': () => Promise.resolve(locale86f4b04c),
  'ko.json': () => Promise.resolve(locale2091eb08),
  'nl.json': () => Promise.resolve(localeed699b3c),
  'pl.json': () => Promise.resolve(locale19d0ae38),
  'pt.json': () => Promise.resolve(locale00be6ddc),
  'ru.json': () => Promise.resolve(locale6c3fbcfd),
  'sk.json': () => Promise.resolve(localedfd4fbf0),
  'tu.json': () => Promise.resolve(locale53e79902),
  'ua.json': () => Promise.resolve(locale2e5cfb58),
  'ur.json': () => Promise.resolve(locale05d3e4e3),
  'vt.json': () => Promise.resolve(locale3e23d162),
}
